module.exports = __webpack_public_path__ + "static/media/react_js_development.3af03757.svg";